<template>
  <div>
    <header-component />

    <div class="w-100 d-inline-block bg-introduction py-5 apply-ty-wrap">
      <div class="container autoContent">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="bg-white rounded-4 shadow-sm p-2 p-md-3 text-center apply-ty-card">
              <img
                class="apply-thankyou-img mb-3"
                src="@/assets/images/thank-you-image.png"
                alt="Thank you"
              >

              <div class="apply-ty-title filson-black-family text-uppercase text-black">
                Thank you
              </div>
              <div class="apply-ty-subtitle inter-bold-family text-uppercase text-black">
                For joining the LushGroom family!
              </div>
              <p class="apply-ty-desc mb-0 text-size-14 text-black inter-regular-family text-full-13">
                We’ve received your information and our team is excited to review your application.
                We’ll be in touch within 24–48 hours.
              </p>

              <div class="row g-2 mt-3 text-start apply-ty-grid">
                <div class="col-lg-7 col-12">
                  <div class="apply-ty-next rounded-4 p-2 p-md-3">
                    <div class="apply-ty-next-title inter-bold-family text-black mb-3">What’s Next?</div>

                    <div class="apply-ty-step">
                      <div class="apply-ty-step-num">1</div>
                      <div>
                        <div class="apply-ty-step-title inter-bold-family text-black">Profile Review</div>
                        <div class="apply-ty-step-desc inter-regular-family text-muted text-full-12">
                          Our team will verify your credentials and ensure everything aligns with our standards.
                        </div>
                      </div>
                    </div>

                    <div class="apply-ty-step">
                      <div class="apply-ty-step-num">2</div>
                      <div>
                        <div class="apply-ty-step-title inter-bold-family text-black">Quick Call</div>
                        <div class="apply-ty-step-desc inter-regular-family text-muted text-full-12">
                          A brief discovery call to discuss your business and how we can support your growth.
                        </div>
                      </div>
                    </div>

                    <div class="apply-ty-step mb-0">
                      <div class="apply-ty-step-num">3</div>
                      <div>
                        <div class="apply-ty-step-title inter-bold-family text-black">Onboarding</div>
                        <div class="apply-ty-step-desc inter-regular-family text-muted text-full-12">
                          Set up your profile, define your services, and start accepting premium bookings.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-5 col-12">
                  <div class="apply-ty-side rounded-4 p-2 p-md-3 h-100">
                    <div class="apply-ty-media rounded-4 mb-2">
                      <div class="apply-ty-side-photo rounded-4" aria-hidden="true"></div>
                      <div class="apply-ty-media-badge">
                        <div class="apply-ty-stars" aria-hidden="true">★★★★★</div>
                        <div class="apply-ty-badge-text">
                          Joining LushGroom was the best decision for my salon.
                        </div>
                      </div>
                    </div>

                    <div class="apply-ty-help rounded-4 mt-2 p-2 p-md-3">
                      <div class="apply-ty-help-row">
                        <div>
                          <div class="apply-ty-help-title inter-bold-family text-black text-full-12 mb-1">Need help?</div>
                          <div class="apply-ty-help-desc inter-regular-family text-muted text-full-12">
                            Our support team is here for you.
                          </div>
                        </div>
                        <div class="d-flex gap-2 flex-wrap justify-content-end">
                          <router-link class="apply-ty-chip" to="/contact-us">Support</router-link>
                          <router-link class="apply-ty-chip" to="/contact-us">FAQ</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-3 text-center">
                <router-link class="apply-ty-cta" to="/">
                  Back to home
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'ApplyJoinThankYou',
  components: {
    headerComponent,
    footerComponent,
  },
};
</script>

<style scoped>
.apply-ty-wrap {
  background: #f7e9e2;
}
.apply-ty-card {
  max-width: 728px; /* ~30% smaller than 1040 */
  margin-left: auto;
  margin-right: auto;
}
.apply-thankyou-img {
  width: min(160px, 100%);
  height: auto;
}
.apply-ty-title {
  font-size: 16px;
  letter-spacing: 0.08em;
}
.apply-ty-subtitle {
  font-size: 10px;
  letter-spacing: 0.08em;
  margin-top: 4px;
}
.apply-ty-desc {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.85;
}
.apply-ty-next {
  background: #f1f2f3;
}
.apply-ty-step {
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 10px;
  align-items: start;
  margin-bottom: 14px;
}
.apply-ty-step-num {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 12px;
  color: #111;
}
.apply-ty-side {
  background: #f1f2f3;
}
.apply-ty-media {
  position: relative;
}
.apply-ty-side-photo {
  width: 100%;
  aspect-ratio: 16 / 10;
  background: url("@/assets/images/join-last-page-dog.png") center / cover no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.apply-ty-media-badge {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 6px 8px;
}
.apply-ty-stars {
  color: #f6b73c;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 6px;
}
.apply-ty-badge-text {
  font-size: 10px;
  color: #111;
  line-height: 1.25;
  font-weight: 700;
}
.apply-ty-help {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.apply-ty-help-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
}
.apply-ty-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(248, 114, 31, 0.12);
  color: #f8721f;
  text-decoration: none;
  font-size: 11px;
  font-weight: 700;
}
.apply-ty-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  padding: 9px 16px;
  border-radius: 6px;
  background: #f8721f;
  color: #fff;
  text-decoration: none;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

@media (max-width: 575px) {
  .apply-thankyou-img {
    width: min(170px, 100%);
  }
  .apply-ty-title {
    font-size: 18px;
  }
  .apply-ty-subtitle {
    font-size: 12px;
    line-height: 1.25;
  }
  .apply-ty-desc {
    font-size: 14px;
    line-height: 1.35;
  }
  .apply-ty-next-title {
    font-size: 20px !important;
    margin-bottom: 14px !important;
  }
  .apply-ty-step-title {
    font-size: 16px !important;
    line-height: 1.28 !important;
  }
  .apply-ty-step-desc {
    font-size: 14px !important;
    line-height: 1.38 !important;
    opacity: 0.95;
  }
  .apply-ty-help-title {
    font-size: 16px !important;
    line-height: 1.28 !important;
  }
  .apply-ty-help-desc {
    font-size: 14px !important;
    line-height: 1.38 !important;
    opacity: 0.95;
  }
  .apply-ty-step {
    margin-bottom: 12px;
  }
  .apply-ty-step-num {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  .apply-ty-badge-text {
    font-size: 12px;
  }
  .apply-ty-chip {
    font-size: 13px !important;
  }
  .apply-ty-cta {
    min-width: 220px;
  }
  .apply-ty-help-row {
    grid-template-columns: 1fr;
  }

  /* Override existing global utility sizes inside this page */
  .apply-ty-card :deep(.text-full-12),
  .apply-ty-card :deep(.text-full-13),
  .apply-ty-card :deep(.text-size-14) {
    font-size: 14px !important;
    line-height: 1.38 !important;
  }
}
</style>

